export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'manual';

export type ShareResult = { outcome: ShareOutcome; copied: boolean };

/** The canonical link excludes board filters, fragments and tracking parameters. */
export function communityPostShareUrl(postId: number): string {
  return `https://www.foreducator.com/community/board/${postId}`;
}

/** Start the write in the same click as sharing. Awaiting it first can expire the share gesture. */
function beginCopy(browser: Pick<Navigator, 'clipboard'>, url: string): Promise<boolean> {
  try {
    const writeText = browser.clipboard?.writeText;
    if (typeof writeText !== 'function') return Promise.resolve(false);
    return writeText.call(browser.clipboard, url).then(() => true, () => false);
  } catch {
    return Promise.resolve(false);
  }
}

export async function shareCommunityPost(
  title: string,
  url: string,
  browser: Pick<Navigator, 'share' | 'clipboard'> = navigator,
): Promise<ShareResult> {
  const copiedPromise = beginCopy(browser, url);
  if (typeof browser.share === 'function') {
    try {
      // Keep the share call synchronous with the user's click (no preceding fetch).
      await browser.share({ title: `${title} | Foreducator`, url });
      return { outcome: 'shared', copied: await copiedPromise };
    } catch (error) {
      const copied = await copiedPromise;
      if (error instanceof Error && error.name === 'AbortError') {
        return { outcome: copied ? 'copied' : 'cancelled', copied };
      }
      if (copied) return { outcome: 'copied', copied };
    }
  }
  const copied = await copiedPromise;
  return { outcome: copied ? 'copied' : 'manual', copied };
}
